import type { RefineProps } from '@refinedev/core';
import { createQueryClient } from './queryClient';

// Mounted only by App. Hooks take the client from context, never from this import.
export const appQueryClient = createQueryClient();

// Refine gets the app's client: without it Refine builds its own, and the MutationCache never
// sees a Refine save. Direct apiClient writes call invalidateProgress (docs/SERVICE_LAYER.md).
export const refineOptions = {
  reactQuery: { clientConfig: appQueryClient },
  syncWithLocation: true,
  warnWhenUnsavedChanges: true,
} satisfies RefineProps['options'];
